<template>
  <div>
    <!-- Hero -->
    <div class="bg-body-light">
      <div class="content content-full">
        <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center py-2 text-center text-sm-left">
          <div class="flex-sm-fill">
            <h1 class="h3 font-w700 mb-2">
              Dashboard
            </h1>
          </div>
        </div>
      </div>
    </div>
    <!-- END Hero -->

    <!-- Page Content -->
    <div class="content">
      <!-- Stats -->
      <b-row>
        <!-- <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Students
              </div>
              <div class="font-size-h3">
                {{students.length}}
              </div>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col> -->
        <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Subscriptions
              </div>
              <div class="font-size-h3">
                {{subscriptions.length}}
              </div>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-danger-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
       <!-- <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Profiles
              </div>
              <div class="font-size-h3">
                100
              </div>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
        <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Organization
              </div>
              <div class="font-size-h3">
                100
              </div>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-danger-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>-->
      </b-row>
      <!-- END Stats -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      students: "",
      subscriptions:"",
    };
  },
  mounted() {
    // this.getCollegeUsers();
    this.getCollegeSubscriptions();
  },
  methods: {
  //  async getCollegeUsers() {
  //     await axios
  //       .get(
  //         `${this.$store.getters.baseUrl}/college_users_list/${this.$route.params.collegeId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${this.$store.getters.collegeToken}`,
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         console.log(response);
  //         if (response.data.status == "success") {
  //           this.students = response.data.college_users;
  //         } else {
  //           this.$swal("Error", response.data.message, "warning");
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         this.$swal("Error", error.response.data.message, "error");
  //       });
  //   },
     async getCollegeSubscriptions() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_subscriptions`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  }
}
</script>
